export const PAYMENT_TYPE_ID = {
  CARD: 20,
  BACS_DIRECT_DEBIT: 22,
  PAY_BY_BANK: 27,
} as const;

export const PAYMENT_METHOD = {
  CARD: 'card',
  BACS_DIRECT_DEBIT: 'bacs-direct-debit',
  PAY_BY_BANK: 'pay-by-bank',
} as const;

export const PAYMENT_PROCESSOR = {
  STRIPE: 'stripe',
  TRANSFERMATE: 'transfermate',
} as const;

export const PAYMENT_METHOD_LABEL = {
  CARD: 'Credit/Debit',
  BACS_DIRECT_DEBIT: 'BACS Direct Debit',
  PAY_BY_BANK: 'Pay by Bank',
} as const;

export const STRIPE_PAYMENT = {
  MEMO: 'Application fee',
  REFERENCE_TYPE: 'application',
} as const;

export const INTERNATIONAL_PAYMENT_NR_ACTION = {
  INITIATED: 'PaymentInitiated',
  CHECKOUT_CREATED: 'PaymentCheckoutCreated',
  RETURN_RECEIVED: 'PaymentReturnReceived',
  COMPLETED: 'PaymentCompleted',
  FAILED: 'PaymentFailed',
  PROCESSED_FLAG_UPDATE_FAILED: 'PaymentProcessedFlagUpdateFailed',
  FX_INITIATED: 'PaymentFxInitiated',
  FX_COMPLETED: 'PaymentFxCompleted',
  FX_FAILED: 'PaymentFxFailed',
} as const;

export const INTERNATIONAL_PAYMENT_RETURN_STORAGE = {
  FLAG: 'is_international_stripe_return',
  PAYMENT_ID: 'ar_payment_id',
  STRIPE_PAYMENT_KEY: 'stripe_payment_key',
  PAYMENT_METHOD: 'international_payment_method',
} as const;

export const TRANSFERMATE_PAYMENT_RETURN_STORAGE = {
  FLAG: 'is_tm_card_return',
  PAYMENT_KEY: 'tm_payment_key',
} as const;

export const INTERNATIONAL_PAYMENT_STATUS = {
  IDLE: 'idle',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const;

export const STRIPE_RETURN_OPERATION = {
  SUCCESS: 'success',
  CANCEL: 'cancel',
} as const;

export const PAYMENT_OPERATION_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
} as const;

export const PAYMENT_MESSAGE = {
  INTERNATIONAL_PAYMENT_UNAVAILABLE:
    'This payment page has not been activated for your account yet. No transaction has been attempted, and your account has not been charged.',
  TERMS_REQUIRED: 'Please agree to the terms and conditions',
  METHOD_NOT_AVAILABLE: 'The selected payment method is not available for payment yet.',
  TRANSFERMATE_NOT_AVAILABLE: 'TransferMate card payment processing is not available yet.',
  TRANSFERMATE_FIELDS_REQUIRED: 'Please complete all required TransferMate fields.',
  INVALID_AMOUNT: 'Please provide a valid payment amount.',
  INVALID_STRIPE_RESPONSE: 'Unable to start the Stripe payment. Please try again.',
  INVALID_TRANSFERMATE_RESPONSE: 'Unable to start the TransferMate payment. Please try again.',
  TRANSFERMATE_PAYMENT_FAILED: 'Unable to process the TransferMate payment. Please try again.',
  PROCESSING: 'Processing payment',
  VERIFYING_PAYMENT: 'Verifying your payment',
  PAYMENT_FAILED: 'Your payment could not be completed. Please try again.',
  PAYMENT_ID_MISMATCHED: 'Invalid transaction.',
  PAYMENT_CANCELLED: 'Failed to process the payment. Please try again.',
  TRANSFERMATE_PENDING: 'Your TransferMate payment is still processing. Please try again later.',
  BACS_AUTO_PAYMENT_DISCLAIMER:
    'You will be redirected to Stripe Checkout to finalize your payment. Please note, paying via Bacs Direct Debit will authorise the property to automatically debit your account for this and any future charges.',
} as const;

export const PAYMENT_TERMS_LINK_LABEL = 'Payment Terms & Conditions';

export const TRANSFERMATE_TERMS_LINK =
  'https://transfermateeducation.com/student-terms-of-use.aspx';

export const PAYMENT_DISCLAIMER =
  'Your application will be completed once we receive confirmation of your payment. Thank you.';
